export default __webpack_public_path__ + "static/media/BlueCircleDesktop.8c5ef369.svg";